// Element ui
import Element from "element-ui";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import VueInjectJs from "vue-inject-js";
import { default as Vuedals } from "vuedals";

// Vuedals
Vue.use(Vuedals);

// Highcharts
import VueHighcharts from "vue-highcharts";
Vue.use(VueHighcharts);

Vue.use(Element, { size: "large" });
locale.use(lang);
Vue.use(VueInjectJs);

// Croppie
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
Vue.use(VueCroppie);

// Time / date
import moment from "moment";
Vue.prototype.moment = moment;

// Validate
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { setInteractionMode } from "vee-validate";

setInteractionMode("eager");

extend("phone", (value) => {
	if (value.match(/^([ 0-9+]*)$/)) {
		return true;
	}
	return "Invalid phone";
});

// No message specified.
extend("email", {
	...email,
	message: "Invalid email",
});

// Override the default message.
extend("required", {
	...required,
	message: "This field is required",
});

// Register it globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);



// WEBPACK FOOTER //
// ./src/vendor.js